<template>
    <b-modal
        :id="'assignment-edit-part-colorlist-options-modal-' + partIn.id"
        title="Kleuren keuzelijst bewerken"
        ok-only
        :ok-title="$t('common.save')"
        modal-class="clean-modal"
        ok-variant="primary">
        <div class="color-select-list-answer-options">
            <label>{{ $t('assignment.part_type.color_options') }}</label>
            <div
                class="colors"
                v-if="colors.length">
                <div
                    class="color-answer"
                    v-for="color of colors">
                    <b-form-checkbox
                        :checked="!!color.option"
                        switch
                        @change="updateColorSelection($event, color)">
                        {{ color.name }}
                    </b-form-checkbox>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-edit-part-colorlist-options-modal-component',
    props: {
        partIn: Object,
    },
    data() {
        return {
            partsUpdated: this.partIn,
            colors: this.createColorArray(),
        };
    },
    watch: {
        partIn: function (part) {
            this.colors = this.createColorArray();
        },
    },
    methods: {
        updateColorSelection(checked, color) {
            if (!color.option) {
                this.addAssignmentPartColorOption(color.value);
            } else {
                this.deleteAssignmentPartColorOption(color.option);
            }
        },

        deleteAssignmentPartColorOption(option) {
            this.axios.delete(this.routes.assignmentPartListOptionDelete(this.partIn.id, option.id)).then(
                (response) => {
                    option.remove();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        addAssignmentPartColorOption(color) {
            const data = {
                part_id: this.partIn.id,
                value: color,
            };

            this.axios.post(this.routes.assignmentPartListOptionAdd(this.partIn.id), data).then(
                (response) => {
                    this.partIn.addRelation('list_options', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        createColorArray() {
            return [
                {
                    name: this.$t('common.red'),
                    value: '#f35958',
                    option: this.partIn.getListOptionByValue('#f35958'),
                },
                {
                    name: this.$t('common.blue'),
                    value: '#007bff',
                    option: this.partIn.getListOptionByValue('#007bff'),
                },
                {
                    name: this.$t('common.orange'),
                    value: '#ffb548',
                    option: this.partIn.getListOptionByValue('#ffb548'),
                },
                {
                    name: this.$t('common.green'),
                    value: '#0acf97',
                    option: this.partIn.getListOptionByValue('#0acf97'),
                },
            ];
        },
    },
};
</script>

<style scoped lang="scss">
.color-select-list-answers {
    display: flex;
    flex-direction: column;
}

.color-select-list-answers-faq {
    flex: 1 0;
    margin-right: 0;
    margin-bottom: 21px;
    padding-bottom: 21px;
    border-bottom: 1px solid #eee;
}

.color-select-list-answer-options {
    margin-left: 0;
}

.select-list-question-title {
    display: flex;
    margin-bottom: 15px;
}

.btn-add-select-qa {
    display: inline-flex;
    flex: 0 1;
    margin-right: auto;
}

.btn-add-select-qa i,
.btn-add-option i {
    display: flex;
    align-self: center;
}

.select-list-question-title input,
.option input {
    margin-right: 15px;
}

@media (min-width: 768px) {
    .color-select-list-answers {
        flex-direction: row;
    }

    .color-select-list-answers-faq {
        margin-bottom: 0;
        padding-bottom: 0;
        margin-right: 30px;
        border: none;
    }

    .color-select-list-answer-options {
        margin-left: auto;
    }
}
</style>
